"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  return {
    forgotPassword: {
      "& .mco-form": {
        flexDirection: "column"
      },
      "& .mco-form-input:not(.mco-form-textarea):not(.mco-form-file)": {
        flex: 1
      }
    },
    backLink: {
      marginBottom: theme.spacing(2),
      "& a": {
        alignItems: "center",
        cursor: "pointer",
        display: "flex",
        fontWeight: theme.typography.fontWeightBold
      }
    },
    backLinkIcon: {
      marginRight: theme.spacing(1)
    },
    headline: {
      fontSize: 24,
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(1)
    },
    text: {
      marginBottom: theme.spacing(2)
    }
  };
});
var _default = styles;
exports.default = _default;